import React, {Fragment} from 'react';
import {Button, IconButton} from '@mui/material';
import Icon from 'presentation/icons';
import {Snackbar} from 'presentation/components';
import {FavoriteButtonProps} from './types';
import {useFavoriteDoctorsLikeButton} from './hooks/useFavoriteDoctorsLikeButton';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {FeaturesEnum} from 'presentation/constants';
import {useContractStatus} from 'presentation/hooks';
import {Loading} from 'presentation/components/Loading/Loading';
import {translations} from 'presentation/translations-new';

const {remove, add} = translations['pt-br'].commons;

const FavoriteDoctorsLikeButton = ({
	selected = false,
	cdPrestador,
	cdEspecialidade,
	cdSubEspecialidade,
	disabled,
	iconColor,
	hideButton,
	asButton,
	...props
}: FavoriteButtonProps) => {
	const {
		isSelected,
		handleToggleFavorite,
		openSnackbar,
		snackBarMessage,
		setOpenSnackbar,
		isLoading,
		colors,
	} = useFavoriteDoctorsLikeButton({
		selected,
		cdPrestador,
		cdEspecialidade,
		cdSubEspecialidade,
	});

	const {isContractSuspended} = useContractStatus();

	const {isEnabled: isFavoriteDoctorsEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_FAVORITE_DOCTORS,
	);

	if (!isFavoriteDoctorsEnabled || isContractSuspended || hideButton) {
		return null;
	}

	return (
		<Fragment>
			{asButton ? (
				<Button
					onClick={handleToggleFavorite}
					disabled={disabled || isLoading}
					variant={isSelected ? 'outlined' : 'contained'}
					color={isSelected ? 'error' : 'primary'}
					endIcon={isLoading ? <Loading size={16} color="inherit" /> : null}
					size="small">
					{isSelected ? remove : add}
				</Button>
			) : (
				<IconButton
					{...props}
					size="small"
					onClick={handleToggleFavorite}
					loading={isLoading}
					disabled={disabled}>
					{isSelected ? (
						<Icon
							name="heart-filled"
							color={isLoading ? undefined : colors.light.error.main}
						/>
					) : (
						<Icon
							name="heart-outline"
							color={isLoading ? undefined : iconColor || colors.gray['50Percent']}
						/>
					)}
				</IconButton>
			)}
			<Snackbar
				open={openSnackbar}
				onClose={() => setOpenSnackbar(false)}
				message={snackBarMessage}
			/>
		</Fragment>
	);
};

export {FavoriteDoctorsLikeButton};
